import { getActivePinia } from 'pinia';
import type { Pinia, Store } from 'pinia';

interface ExtendedPinia extends Pinia {
  _s: Map<string, Store>;
}

// 定義 store 的 reset 方法型別
type StoreWithReset = Store & {
  reset?: () => void;
};

export function useResetStore() {
  const pinia = getActivePinia() as ExtendedPinia;

  if (!pinia) {
    throw new Error('There is no active Pinia instance');
  }

  const resetStore: Record<string, () => void> = {};

  for (const [name, store] of pinia._s) {
    resetStore[name] = () => {
      const storeWithReset = store as StoreWithReset;

      // 直接使用手動實作的 reset() 方法
      if (typeof storeWithReset.reset === 'function') {
        storeWithReset.reset();
      } else {
        console.warn(`Store "${name}" does not have a reset method`);
      }
    };
  }

  resetStore.all = () => {
    for (const [name, store] of pinia._s) {
      const storeWithReset = store as StoreWithReset;

      // 直接使用手動實作的 reset() 方法
      if (typeof storeWithReset.reset === 'function') {
        storeWithReset.reset();
      } else {
        console.warn(`Store "${name}" does not have a reset method`);
      }
    }
  };
  return resetStore as typeof resetStore & { all: () => void };
}
